module.exports = __webpack_public_path__ + "8e68ea6ff04ee30e24050f7daef24fe7.MP3";